import OptionsTypeConfig from './OptionsTypeConfig';

export default class DropdownTypeConfig extends OptionsTypeConfig{

}
